export default __webpack_public_path__ + "static/media/fab.3c2e5b20.svg";